import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DealerService } from './../../../../business-entities/dealer-service.interface';
import { CommonService } from 'projects/Widget/src/app/services/commom.service';
import { AvailableDelearService } from './../../../../business-entities/available-service';
import { EnvSetting } from 'projects/Autofacets-Core/src/app/utils/env-setting';

@Component({
  selector: 'app-select-dealer',
  templateUrl: 'select-dealer.component.html',
  styleUrls: []
})
export class SelectDealerComponent implements OnInit {
  
  @Input() allDealerDetails: DealerService[] = [];
  showMapSection = false;
  @Input() latitude: number;
  @Input() longitude: number;
  @Input() preferedDealer: DealerService;
  @Input() customerPickupDropOffServiceSelection:boolean;
  selectDealerData: FormGroup;
  openedWindow = 0;
  selectedNearestDealer: AvailableDelearService;
  globalSearch: string;
  dealersWithLatLong: DealerService[] = [];
  dealerFilter: any = {
    dealerName: '',
    address: '',
    pincode: '',
    city: ''
  };

  constructor(
    public activeModal: NgbActiveModal,
    private commonService: CommonService,
  ) { }

  ngOnInit(): void {
    this.loadGoogleMapsScript();
    this.checkNotAvailableServices();
    const index = this.allDealerDetails.findIndex(x => x.dealerId === this.preferedDealer.dealerId);
    const dealerId = index === -1 ? null : this.allDealerDetails[index].dealerId;
    this.selectDealerData = new FormGroup({
      selectedDealer: new FormControl(dealerId, [Validators.required])
    });
  }

  applyNGXFilter(): void {
    this.dealerFilter = {
      $or: [
        { dealerName: this.globalSearch },
        { address: this.globalSearch },
        { pincode: this.globalSearch },
        { city: this.globalSearch }
      ]
    };
  }

  checkNotAvailableServices(): void {
    const appdata = this.commonService.getAppData();
    this.allDealerDetails.forEach(dealer => {
      const serviceList = appdata.selectedService.filter(x => {
        if (dealer.service) { return dealer.service.findIndex(y => y.serviceId === x.id) === -1; }
        return true;
      }).map(x => x.name).join(', ');
      dealer.notAvailableServices = serviceList.length > 0 ? serviceList : undefined;
      return dealer;
    });
    
    const dealerArr = this.allDealerDetails.filter(x => x.distance !== 0).sort((x, y) => x.distance - y.distance);
    dealerArr.push(...this.allDealerDetails.filter(x => x.distance === 0));
    this.allDealerDetails = dealerArr.slice();
    
    this.dealersWithLatLong = this.allDealerDetails.map(x => ({
      ...x,
      latitude: x.latitude ? x.latitude : '0',
      longitude: x.longitude ? x.longitude : '0'
    })).filter(x => +x.latitude !== 0 && +x.longitude !== 0);
    
    if (this.latitude === 0) {
      this.latitude = this.dealersWithLatLong.length > 0 ? +this.dealersWithLatLong[0].latitude : 0;
    }
    if (this.longitude === 0) {
      this.longitude = this.dealersWithLatLong.length > 0 ? +this.dealersWithLatLong[0].longitude : 0;
    }
  }

  selectDealerFromMap(dealer): void {
    const dealerId = dealer.dealerId;
    this.activeModal.close(dealerId);
  }

  openWindow(id): void {
    this.openedWindow = id;
  }

  isInfoWindowOpen(id): boolean {
    return this.openedWindow === id;
  }

  closeDealerListModel(): void {
    const dealerId = this.selectDealerData.controls.selectedDealer.value;
    this.activeModal.close(dealerId);
  }

  loadGoogleMapsScript() {
    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${EnvSetting.googleKey}`;
    script.async = true;
    script.defer = true;
    document.head.appendChild(script);
  }
}
